module.exports = __webpack_public_path__ + "static/media/nutrientes.f15f5ee9.jpg";